import React, {lazy, Suspense} from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicOnlyRoute from './PublicOnlyRoute';
import CustomerProtectedRoute from './CustomerProtectedRoute';

import Layout from "./../layout/Layout";

const Home 				=	lazy(()=> import("./../components/Home"));
const PropertyList 		=	lazy(()=> import("./../components/PropertyList"));
const PropertyMapList 	=	lazy(()=> import("./../components/PropertyMapList"));
const PropertyDetails	=	lazy(()=> import("./../components/PropertyDetails"));
const HostDetail		=	lazy(()=> import("./../components/hostDetail"));
const Login 			=	lazy(()=> import("./../components/Login"));
const Signup 			=	lazy(()=> import("./../components/Signup"));
const Verify 			=	lazy(()=> import("./../components/verify"));
const UserVerifyByLogin =	lazy(()=> import("./../components/UserVerifyByLogin"));
const ScrollToTop 		=	lazy(()=> import("./../ScrollToTop"));


/** Customer Protected Components*/ 
const MyBooking 			=	lazy(()=> import("./../components/Customer/MyBooking"));
const BookingDetail 		=	lazy(()=> import("./../components/Customer/BookingDetail"));
const BookingRatingReview	=	lazy(()=> import("./../components/Customer/BookingRatingReview"));
const Chatbox 				=	lazy(()=> import("./../components/Customer/Chatbox"));
const Profile 				=	lazy(()=> import("./../components/Customer/Profile"));
const Wishlist 				=	lazy(()=> import("./../components/Customer/Wishlist"));
const CheckOut				=	lazy(()=> import("./../components/Customer/checkOut"));
const PayAndConfirmBooking 	=	lazy(()=> import("./../components/Customer/PayAndConfirmBooking"));
const BookingConfirmPage 	=	lazy(()=> import("./../components/Customer/BookingConfirmPage"));

const PaymentSuccessPage 	=	lazy(()=> import("./../components/PaymentSuccess"));
const PaymentFailedPage 	=	lazy(()=> import("./../components/PaymentFailed"));
const PaymentResponsePage	=	lazy(()=> import("./../components/PaymentResponsePage"));
const TriplePaymentResponse	=	lazy(()=> import("./../components/TriplePaymentResponse"));
const KYCSuccessPage 		=	lazy(()=> import("./../components/KYCSuccessPage"));
const KycUpdatePage 		=	lazy(()=> import("./../components/KYCUpdatePage"));

const CmsPage				=	lazy(()=> import("./../components/CmsPage"));
const FaqPage				=	lazy(()=> import("./../components/FaqPage"));
const Page404				=	lazy(()=> import("./../components/Page404"));

export default function AppRoutes() {
	return (
		<BrowserRouter>
			<Suspense fallback={<div></div>}>
				<ScrollToTop />
				<Routes>
					<Route path="/" element={<Layout />}>
						<Route index element={<Home />} />
						<Route path="/property" element={<PropertyList />} />
						<Route path="/category/:category_slug" element={<PropertyList />} />
						<Route path="/city/:slug" element={<PropertyList />} />
						<Route path="/property-map" element={<PropertyMapList />} />
						<Route path="/property/:slug" element={<PropertyDetails />} />
						<Route path="/host/:slug" element={<HostDetail />} />
						<Route path="/faq" element={<FaqPage />}  />

						<Route path="/terms-conditions" element={<CmsPage pageSlug="terms-conditions" />}  />
						<Route path="/privacy-policy" element={<CmsPage pageSlug="privacy-policy" />}  />
						<Route path="/about-us" element={<CmsPage pageSlug="about-us" />}  />
						<Route path="/help" element={<CmsPage pageSlug="help" />}  />

						<Route path="/payment-response/:booking_id/:event" element={<PaymentResponsePage />} />
						<Route path="/triple-payment-response/:booking_id/:event_type" element={<TriplePaymentResponse />} />

						
						<Route path="/payment-failed" element={<PaymentFailedPage />} />
						<Route path="/kyc-response" element={<KYCSuccessPage />} />
						<Route path="/kyc-updation/:user_id" element={<KycUpdatePage />}  />

						<Route element={ <PublicOnlyRoute/> }>
							<Route path="/login" element={<Login />} />
							<Route path="/sign-up" element={<Signup />} />
							<Route path="/verify/:validate_string" element={<Verify />} />
							<Route path="/user-verification" element={<UserVerifyByLogin />} />

						</Route>
						<Route element={ <CustomerProtectedRoute/> }>
							<Route path="/bookings" element={<MyBooking />} />
							<Route path="/bookings/:booking_number" element={<BookingDetail />} />
							<Route path="/bookings_ratings/:booking_number" element={<BookingRatingReview />} />
							<Route path="/my-profile" element={<Profile />}  />
							<Route path="/my-chatbox/:booking_id" element={<Chatbox />}  />
							<Route path="/my-wishlist" element={<Wishlist />}  />
							<Route path="/checkout/:booking_id" element={<CheckOut />} />
							<Route path="/confirm_booking" element={<PayAndConfirmBooking />} />
							<Route path="/booking-confirmation/:booking_id" element={<BookingConfirmPage />} />
							<Route path="/payment-success/:booking_id" element={<PaymentSuccessPage />} />
						</Route>
						<Route path="*" element={<Page404 />} />
					</Route>
				</Routes>
			</Suspense>
		</BrowserRouter>
	);
}
